// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3Qxvh","selected":"Chip_selected__KJIjB"};